import React from "react";

import { Bounce1, Bounce2, Bounce3, Spinner, SpinnerProps } from "./styles";

export const Loader: React.FC<SpinnerProps> = ({ size = "l", text, ...rest }) => {
  return (
    <>
      {text && (
        <h3
          style={{
            textAlign: "center",
            width: "100%",
            fontWeight: "bold",
            fontSize: "1.5rem",
          }}
        >
          {text}
        </h3>
      )}
      <Spinner size={size} {...rest}>
        <Bounce1 />
        <Bounce2 />
        <Bounce3 />
      </Spinner>
    </>
  );
};
